import emitter from 'mitt';
import * as locationClient from '../lib/location-client';
import storage from '../lib/storage';

// TODO: Use ES6 Set https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set
const initialState = {
	primary: {}, // Primary is the geolocation.
	current: {},
	favorites: [],
	recent: [],
	searchResults: []
};

/**
 * The location model. :rocket:
 */
export default function createLocationModel({ config = {} }) {
	const events = emitter();

	let state = { ...initialState, ...(config.initialState || {}) };

	function refresh() {
		events.emit('refresh', state);
	}

	function init() {
		const { apiOrigin, defaultLocation } = config;
		apiOrigin && locationClient.setAPIOrigin(apiOrigin);

		storage.init(defaultLocation)
			.then((nextState) => {
				state = Object.assign({}, state, nextState);
				refresh();
			});

		events.on('refresh', ({ primary, current, favorites, recent }) => {
			const saveState = { primary, current, favorites, recent };
			storage.set(saveState);
		});
	}

	const is = {
		primary: (location) => state.primary.id === location.id,
		current: (location) => state.current.id === location.id,
		favorites: (location) => Boolean(state.favorites.filter((favoriteLocation) => favoriteLocation.id === location.id).length),
		recent: (location) => Boolean(state.recent.filter((recentLocation) => recentLocation.id === location.id).length)
	};

	const get = {
		primary: () => state.primary,
		current: () => state.current,
		favorites: () => state.favorites,
		recent: () => state.recent,
		searchResults: () => state.searchResults
	};

	const set = {
		current: (location) => { state.current = location; },
		favorites: (locations) => { state.favorites = locations; },
		recent: (locations) => { state.recent = locations; }
	};

	const actions = {
		change: {
			current: (newCurrent) => {
				if (!is.current(newCurrent)) {
					set.current(newCurrent);
					refresh();
				}
			},
			favorites: (newFavorites) => {
				set.favorites(newFavorites);
				refresh();
			},
			recent: (newRecent) => {
				set.recent(newRecent);
				refresh();
			},
			searchTerm: (searchTerm) => (
				locationClient.search(searchTerm, config.international)
					.then((results) => {
						state.searchResults = results;
						refresh();
					})
			)
		}
	};

	const on = {
		refresh: function refresh(callback) {
			events.on('refresh', callback);
			callback(state); // Immediately send a refresh to the new subscriber, to ensure they have the latest state.

			return function destroy() {
				events.off('refresh', callback);
			};
		}
	};

	init();

	return {
		setAPIOrigin: locationClient.setAPIOrigin,
		on,
		is,
		get,
		set,
		actions
	};
}
